import { render, staticRenderFns } from "./startpageModern.vue?vue&type=template&id=3fcaff20"
import script from "./startpageModern.vue?vue&type=script&lang=js"
export * from "./startpageModern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports